import { Skeleton } from "components/ui/skeleton";

import type { MonthView } from "../types";
import { MonthCard } from "./month-card";

interface MonthGridProps {
  views: MonthView[];
  isLoading: boolean;
  selectedYear: number;
  currentYear: number;
  currentMonth: number;
  onCardClick: (view: MonthView) => void;
}

export function MonthGrid({
  views,
  isLoading,
  selectedYear,
  currentYear,
  currentMonth,
  onCardClick,
}: MonthGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {Array.from({ length: 12 }).map((_, i) => (
          <Skeleton key={i} className="h-36 rounded-lg" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {views.map((view, i) => {
        const monthNum = i + 1;
        const isCurrentMonth =
          selectedYear === currentYear && monthNum === currentMonth;
        const isFuture =
          selectedYear > currentYear ||
          (selectedYear === currentYear && monthNum > currentMonth + 2);

        return (
          <MonthCard
            key={i}
            view={view}
            isCurrentMonth={isCurrentMonth}
            isFuture={isFuture}
            onClick={onCardClick}
          />
        );
      })}
    </div>
  );
}
